import { put, call, throttle } from "redux-saga/effects";
import {
  makeBooking,
  getWaitTimes,
  cancelBooking,
  updateBooking,
  getSessionApi,
  makeReservationApiV3,
  getBookingV3,
  // getWaitlistEntriesV3,
} from "./checkInAPI";
import {
  CHECKIN_REQUEST,
  CHECKIN_REVAMP_REQUEST,
  WAITTIME_REQUEST,
  CHECKIN_UPDATE_REQUEST,
  CHECKIN_CANCEL_REQUEST,
  CHECKIN_DETAILS_REQUEST,
  GET_RESERVATION_SESSION_REQUEST,
  RESERVATION_TIMESTAMP,
  RESERVATION_REQUEST,
} from "./checkInConstants";
import {
  successBooking,
  failedBooking,
  CheckInActions,
  successWaitTimes,
  failedWaitTimes,
  successCancelBooking,
  failedCancelBooking,
  successEditBooking,
  failedEditbooking,
  successGetBooking,
  failedGetBooking,
  sessionDataSuccess,
  sessionDataFaliure,
  failedReservation,
  successReservation,
} from "./checkInActions";
import {
  CheckInBookingForm,
  WaitTimeRestaurantDetail,
  CancelCheckInDetails,
  CheckInBookingDetails,
  CheckInSuccessResult,
} from "./checkInModels";
import { CURRENT_CHECKIN_RESERVATION_ID, EXPIRE_TIME, RESERVATION_EXPIRE_TIME } from "../../constants";
import { AxiosResponse } from "axios";
import { decryptJson } from "../../utils/react-ec-utils";
import { formatTime } from "../../../reservation-revamp/utils/timeUtils";
import { validateAndParseResponse } from "../../utils/hmac-utils";
import { showErrorToast, showErrorToastDesktop } from "../../utils/toastUtils";

const getCheckInDetails = (data: CheckInBookingForm) => {
  const CheckInMetaData = {
    deviceId: "",
    channelName: "ONLINE",
    seatTogether: "1",
  };

  let checkInDetails = Object.assign({}, data as any);
  // checkInDetails["partySize"] =
  //   parseInt(checkInDetails["adultSize"]) +
  //   (parseInt(checkInDetails["kidSize"]) || 0);
  delete checkInDetails["adultSize"];
  delete checkInDetails["restaurantSlug"];
  checkInDetails = Object.assign(
    {},
    checkInDetails,
    CheckInMetaData
  ) as CheckInBookingDetails;
  return checkInDetails;
};


const getReservationDetails = (data: CheckInBookingForm) => {
  const CheckInMetaData = {
    deviceId: "",
    channelName: "ONLINE",
    seatTogether: "1",
  };

  let checkInDetails = Object.assign({}, data as any);
  // checkInDetails["partySize"] =
  //   parseInt(checkInDetails["adultSize"]) +
  //   (parseInt(checkInDetails["kidSize"]) || 0);
  delete checkInDetails["adultSize"];
  delete checkInDetails["restaurantSlug"];
  checkInDetails = Object.assign(
    {},
    checkInDetails,
    CheckInMetaData
  ) as CheckInBookingDetails;
  return checkInDetails;
};

function storeTimestamp(timestamp: string) {
  const existing = localStorage.getItem(RESERVATION_TIMESTAMP);
  let times: string[] = [];

  if (existing) {
    times = JSON.parse(existing);
  }

  times.push(timestamp);

  localStorage.setItem(RESERVATION_TIMESTAMP, JSON.stringify(times));
}

function* makeBookingSaga(action: CheckInActions) {
  try {
    const checkInDetails = getCheckInDetails(
      action.payload as CheckInBookingForm
    );

    const response: AxiosResponse = yield call(makeBooking, checkInDetails);

    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText);
      const responseData = data as CheckInSuccessResult;
      //Store Latest CheckIn ReservationID
      localStorage.setItem(
        EXPIRE_TIME,
        JSON.stringify(new Date().setMinutes(new Date().getMinutes() + 5))
      );
      localStorage.setItem(CURRENT_CHECKIN_RESERVATION_ID, responseData.id);
      const checkIndetails={
        locationId:action.payload.locationId,
        checkInId:responseData.id,
        status:"Active"
      }
            const existing = localStorage.getItem('ActiveCheckIns');
            const activeCheckIns = existing ? JSON.parse(existing) : [];
            activeCheckIns.push(checkIndetails);
            localStorage.setItem('ActiveCheckIns', JSON.stringify(activeCheckIns));
            yield put(successBooking(responseData));
    }
    else {
      if(response.status === 400)
      {
           yield put(failedBooking({
                    message:
                      'Only one checkin is allowed from a phone number and we have detected an active checkin using this phone number. Please contact the host for further queries. Thank you!',
                  }));
      } else {
        yield put(failedBooking({ message: response?.data?.message || "Something went wrong. Please try again." }));
      }

    }
  } catch (err: any) {
    yield put(failedBooking({ message: err?.response?.data?.message || "Something went wrong. Please try again." }));
  }
}

function* makeWaitlistRevampSaga(action: CheckInActions) {
  try {
    const input = action.payload as any;

    const v3Payload: any = {
      locationId: input.locationId,
      partyName: input.partyName,
      partyPhone: input.partyPhone,
      partySize: input.partySize,
      isReservation: 0,
      channelName: input.channelName || "ONLINE",
      isAutoAssign: false,
      isFloorPlanCheckIn: 0,
    };
    if (input.sectionId) v3Payload.sectionId = input.sectionId;
    if (input.notes) v3Payload.notes = input.notes;
    if (input.email) v3Payload.email = input.email;

    const response: AxiosResponse = yield call(makeReservationApiV3, v3Payload);

    if (response.status === 200 || response.status === 201) {
      const data = response.data?.data || response.data;
      const raw = data.reservation || data;

      const responseData: CheckInSuccessResult = {
        id: raw.id || '',
        confirmationNo: raw.confirmationNo || '',
        waitTime: 0,
        isFeedbackSubmitted: false,
        ...raw,
      };

      localStorage.setItem(CURRENT_CHECKIN_RESERVATION_ID, responseData.id);

      const activeEntry = { locationId: input.locationId, checkInId: responseData.id, status: "Active" };
      const existing = localStorage.getItem('ActiveCheckIns');
      const activeCheckIns = existing ? JSON.parse(existing) : [];
      activeCheckIns.push(activeEntry);
      localStorage.setItem('ActiveCheckIns', JSON.stringify(activeCheckIns));

      yield put(successBooking(responseData));
    } else {
      yield put(failedBooking({ message: response?.data?.message || "Something went wrong. Please try again." }));
    }
  } catch (err: any) {
    const errData = err?.response?.data;
    const errMsg = errData?.error?.message || errData?.message || "Something went wrong. Please try again.";
    yield put(failedBooking({ message: errMsg }));
  }
}

function* getWaitTimeSaga(action: CheckInActions) {
  try {
    const response: AxiosResponse = yield call(
      getWaitTimes,
      action.payload as WaitTimeRestaurantDetail
    );
    const decryptdata = decryptJson(response?.data?.encryptedText);
    if (response.status === 200) {
      yield put(successWaitTimes(decryptdata));
    }
  } catch (err) {
    yield put(failedWaitTimes({ message: "WaitTimes couldn't be loaded" }));
  }
}

function* cancelBookingSaga(action: CheckInActions) :any{
    const isMobile = window.innerWidth <= 768;
  try {
    const response: AxiosResponse = yield call(
      cancelBooking,
      action.payload as CancelCheckInDetails
    );
  //  const   parsedResponse = yield call(validateAndParseResponse, response.data);
  //  if (!parsedResponse?.valid) {
  //          if (isMobile) {
  //            showErrorToast(parsedResponse?.message || 'Failed to update profile, Please try Again');
  //          } else {
  //            showErrorToastDesktop(
  //              parsedResponse?.message || 'Failed to update profile, Please try Again'
  //            );
  //          }
  //          return;
  //        }
    if (response.status === 200) {
      yield put(successCancelBooking());
    }
  } catch (err) {
    yield put(failedCancelBooking({ message: "Please Try Again" }));
  }
}

function* updateBookingSaga(action: CheckInActions) {
  try {
    const checkInDetails = getCheckInDetails(
      action.payload as CheckInBookingForm
    );
    const response: AxiosResponse = yield call(updateBooking, checkInDetails);
    if (response.status === 200) {
      yield put(successEditBooking(response.data));
    }
  } catch (err) {
    yield put(failedEditbooking({ message: "Please Try Again" }));
  }
}

function* getBookingSaga(action: CheckInActions) {
  try {
    const response: AxiosResponse = yield call(
      getBookingV3,
      action.payload as string
    );
    if (response.status === 200) {
      const data = response.data?.data || response.data;
      // V3 response wraps under { reservation: {...}, activityLog: [...] }
      const raw = data.reservation || data;
      const normalized: any = {
        ...raw,
        reservationId: raw.id || '',
        reservationStatus: raw.reservationStatus || '',
        confirmationNo: raw.confirmationNo || '',
        partyName: raw.partyName || '',
        partySize: raw.partySize || 0,
        kidSize: raw.kidsSize || raw.kidSize || 0,
        partyPhone: raw.partyPhone || '',
        reservationDate: raw.reservationDate || '',
        reservationSlot: raw.reservationSlot || '',
        sessionName: raw.sessionName || '',
        tableDetails: (raw.tables || []).map((t: any) => ({
          tableName: t.tableName || t.name || '',
          tableId: t.tableId || '',
          sectionName: t.sectionName || '',
        })),
        activityLog: data.activityLog || [],
      };

      // For waitlist entries, fetch queue position
      // if (raw.isReservation === 0 && raw.locationId) {
      //   try {
      //     const listRes: AxiosResponse = yield call(getWaitlistEntriesV3, raw.locationId);
      //     if (listRes.status === 200) {
      //       const listData = listRes.data?.data || listRes.data;
      //       const entries = listData.reservations || listData || [];
      //       // Count active waitlist entries and find position
      //       const activeEntries = entries.filter((e: any) =>
      //         e.isReservation === 0 && ['C', 'L', 'P'].includes(e.reservationStatus)
      //       );
      //       const position = activeEntries.findIndex((e: any) => e.id === raw.id);
      //       normalized.overAllQueueCount = position >= 0 ? position + 1 : activeEntries.length + 1;
      //       normalized.totalQueueCount = activeEntries.length;
      //       normalized.waitlistPosition = normalized.overAllQueueCount;
      //     }
      //   } catch (_) {
      //     // Queue position is non-critical, continue without it
      //   }
      // }

      yield put(successGetBooking(normalized));
    } else {
      yield put(failedGetBooking({ message: response?.data?.message || "Something went wrong. Please try again." }));
    }
  } catch (err: any) {
    yield put(failedGetBooking({ message: err?.response?.data?.message || "Something went wrong. Please try again." }));
  }
}

function* getSessionSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getSessionApi,
      action.payload as string
    );

    if (response.status === 200) {
      const raw = response.data?.data || response.data;
      // V3 response: { sessions: [{ sessionName, slots: [{ slot, bookedCount, maxCapacity, isAvailable, availableTables, availableCombos }] }] }
      // Map to frontend format: [{ sessionName, slots: [{ time, available, availableTables, availableCombos }] }]
      const sessions = (raw.sessions || raw || []).map((s: any) => ({
        sessionName: s.sessionName || '',
        slots: (s.slots || []).map((sl: any) => ({
          time: sl.slot || sl.time || '',
          available: sl.isAvailable === 1 || sl.isAvailable === true || sl.available === true,
          bookedCount: sl.bookedCount ?? 0,
          maxCapacity: sl.maxCapacity ?? 0,
          availableTables: sl.availableTables ?? [],
          availableCombos: sl.availableCombos ?? [],
        })),
      }));
      yield put(sessionDataSuccess(sessions));
    }
  } catch (err) {
    yield put(sessionDataFaliure({ message: "Error" }));
  }
}

function* makeReservationSaga(action: CheckInActions) {
  try {
    const ReservationDetails = getReservationDetails(
      action.payload as CheckInBookingForm
    );

    // Build V3 payload matching POST /reservations spec
    const v3Payload: any = {
      locationId: ReservationDetails.locationId,
      partyName: ReservationDetails.partyName,
      partyPhone: ReservationDetails.partyPhone,
      partySize: ReservationDetails.partySize,
      isReservation: ReservationDetails.isReservation ?? 1,
      reservationDate: ReservationDetails.reservationDate,
      reservationSlot: formatTime(ReservationDetails.reservationSlot),
      sessionName: formatTime(ReservationDetails.sessionName || ReservationDetails.reservationSlot),
      channelName: ReservationDetails.channelName || "ONLINE",
      isAutoAssign: ReservationDetails.isAutoAssign !== false,
      isFloorPlanCheckIn: 0,
    };
    if (ReservationDetails.sectionId) v3Payload.sectionId = ReservationDetails.sectionId;
    if (ReservationDetails.notes) v3Payload.notes = ReservationDetails.notes;
    if (ReservationDetails.tableId) v3Payload.tableId = ReservationDetails.tableId;
    if (ReservationDetails.email) v3Payload.email = ReservationDetails.email;

    const response: AxiosResponse = yield call(
      makeReservationApiV3,
      v3Payload
    );

    if (response.status === 200 || response.status === 201) {
      const data = response.data?.data || response.data;
      // V3 response wraps under { reservation: {...} }
      const raw = data.reservation || data;
      const responseData = {
        ...raw,
        confirmationNo: raw.confirmationNo || '',
        id: raw.id || '',
        reservationId: raw.id || '',
        reservationStatus: raw.reservationStatus || 'B',
        partyName: raw.partyName || v3Payload.partyName,
        partySize: raw.partySize || v3Payload.partySize,
        reservationDate: raw.reservationDate || v3Payload.reservationDate,
        reservationSlot: raw.reservationSlot || v3Payload.reservationSlot,
        tableDetails: (raw.tables || []).map((t: any) => ({
          tableName: t.tableName || t.name || '',
          tableId: t.tableId || '',
          sectionName: t.sectionName || '',
        })),
      } as CheckInSuccessResult;

      localStorage.setItem(
        RESERVATION_EXPIRE_TIME,
        JSON.stringify(new Date().setMinutes(new Date().getMinutes() + 5))
      );
      const [year, month, day] = ReservationDetails.reservationDate
        .split("-")
        .map(Number);

      // JS months are 0-based, so subtract 1 from month
      const formattedDate = new Date(year, month - 1, day);
      const options: Intl.DateTimeFormatOptions = {
        month: "short",
        day: "numeric",
      };

      const datePart = formattedDate.toLocaleDateString("en-US", options);

      const finalFormat = `${datePart}, ${ReservationDetails.reservationSlot}`;
      storeTimestamp(finalFormat);

      yield put(successReservation(responseData));
    } else {
      yield put(failedReservation({ message: response?.data?.message || "Something went wrong. Please try again." }));
    }
  } catch (err: any) {
    const errData = err?.response?.data;
    const errMsg = errData?.error?.message || errData?.message || "Something went wrong. Please try again.";
    yield put(failedReservation({ message: errMsg }));
  }
}

export default function* checkInSaga() {
  yield throttle(5000, CHECKIN_REQUEST, makeBookingSaga);
  yield throttle(5000, CHECKIN_REVAMP_REQUEST, makeWaitlistRevampSaga);
  yield throttle(5000, WAITTIME_REQUEST, getWaitTimeSaga);
  yield throttle(5000, CHECKIN_CANCEL_REQUEST, cancelBookingSaga);
  yield throttle(5000, CHECKIN_UPDATE_REQUEST, updateBookingSaga);
  yield throttle(5000, CHECKIN_DETAILS_REQUEST, getBookingSaga);
  yield throttle(5000, GET_RESERVATION_SESSION_REQUEST, getSessionSaga);
  yield throttle(5000, RESERVATION_REQUEST, makeReservationSaga);
}
